import { requestConfig } from "../config";
import axios, { AxiosRequestConfig } from 'axios'
import { ApiClientResponse, ApiError, ApiGenericResponse, AppRequest } from "../types";
import secureHelper from "./secure.helper";

export function apiHelper<I, O, M>(adapter: AppRequest<I, O, M>, token?: string): Promise<ApiClientResponse<O>> {
    let url = adapter.endpoint.url
    let config = adapter.endpoint.config || requestConfig
    adapter.parameters?.pathVariables?.forEach((value, key) => {
        url = url.replace(key, value)
    })
    if (adapter.parameters?.headers) {
        config = { ...config, headers: { ...config.headers, ...adapter.parameters?.headers } }
    }
    if (token && !adapter.endpoint.thirdParty) {
        config.headers = { ...config.headers, Authorization: `Bearer ${token}` }
    }
    switch (adapter.endpoint.method) {
        case "GET":
            return axios.get(setUrlGetRequest(url, adapter.input), config)
        case "POST":
            return axios.post(url, adapter.input, config)
        default:
            return Promise.reject("Metodo no valido")
    }
}

export function handleImageEnc(src: string, callback: (localUrl: string) => void, token?: string) {
    let config: AxiosRequestConfig<any> = { responseType: 'blob' };
    if (token) {
        config.headers = { Authorization: `Bearer ${token}` }
    }
    axios.get<File>(src, config).then(({ data }) => {
        data.arrayBuffer().then(rawData => {
            let file = secureHelper.decriptFile(rawData);
            callback(URL.createObjectURL(file));
        });
    })
}

function setUrlGetRequest(url: string, input: any) {
    if (input) {
        let params = []
        for (let key in input) {
            params.push(`${key}=${input[key]}`)
        }
        url += `?${params.join('&')}`
    }
    return url
}

export function validateGenericResponse<Input, Output, O>(adapter: AppRequest<Input, Output, O>, response: ApiClientResponse<Output>) {
    return new Promise((resolve: (mappedData: O) => void, reject: (err: ApiError) => void) => {
        if (adapter.isSuccesful?.(response)) {
            return resolve(adapter.output(response.data))
        }

        let data = response.data as ApiGenericResponse<Output>
        let localKey = process.env.REACT_APP_CYPHER || ''
        if (!data.secured) {
            return data.operacionExitosa ? resolve(adapter.output(data.datos)) : reject({
                message: adapter.handleErrorMessage?.(response) || data.mensaje,
                status: response.status
            })
        }
        let message = secureHelper.decriptApiRequest(data.mensaje, localKey)
        let clearStringData = data.operacionExitosa && typeof data.datos === 'string' ? secureHelper.decriptApiRequest(data.datos as string, localKey) : ''
        if (clearStringData) {
            try {
                let clearData = JSON.parse(clearStringData) as Output
                return resolve(adapter.output(clearData))
            } catch (e) {
                console.log(e)
                return resolve(adapter.output(clearStringData as Output))
            }
        }
        console.log(response, adapter.handleErrorMessage?.(response))
        return reject({ message: adapter.handleErrorMessage?.(response) || message, status: response.status })
    })
}

export function completeDummy<Output>(data: any): Promise<ApiClientResponse<Output>> {
    return new Promise((res) => setTimeout(() => res({
        status: 200,
        statusText: 'OK',
        headers: {},
        data: data
    }), 1000))
}